import HTTP from "@/_helpers/http";
import { MAM__WALLET__API } from "@/_helpers/urls";
import { MAM__WALLET__MUTATIONS } from "../mutation-types";
import { MAM__WALLET__ACTIONS } from "../action-types";
import toast from "@/services/Notification";
import router from "@/router";

const state = {
  mam_wallet_summary: null,
  investor_wallet_history: null,
  manager_wallet_history: null,
  wallettransactions: [],
  mamwalletinternaltransferAccount: [],
  walletInternalTransfer: [],
  walletInternalTransferDetails: {
    fromAccountID: null,
    toAccountID: null,
    amount: null,
    otpsent: false,
    client_account_id: null,
    trading_account_no: null,
  },
  mamWalletWithdrawDetails: {
    amount: null,
    wallet_type: null,
    withdraw_method: null,
    wallet_address: null,
    network: null,
    bank_id: null,
    otpsent: false,
  },
};

const getters = {};

const mutations = {
  [MAM__WALLET__MUTATIONS.USERMAMWALLETSUMMARY](state, data) {
    state.mam_wallet_summary = data;
  },
  [MAM__WALLET__MUTATIONS.WALLETTRANSACTIONHISTORY](state, data) {
    state.wallettransactions = data;
  },
  [MAM__WALLET__MUTATIONS.INVESTORWALLETHISTORY](state, data) {
    state.investor_wallet_history = data;
  },
  [MAM__WALLET__MUTATIONS.MANAGERWALLETHISTORY](state, data) {
    state.manager_wallet_history = data;
  },
  [MAM__WALLET__MUTATIONS.MAMWALLETINTERNALTRANSFERACCOUNT](state, data) {
    state.mamwalletinternaltransferAccount = data.result;
  },
  [MAM__WALLET__MUTATIONS.WALLETINTERNALTRANSFERDETAILS](state, data) {
    state.walletInternalTransferDetails.fromAccountID = data.fromAccountID;
    state.walletInternalTransferDetails.toAccountID = data.toAccountID;
    state.walletInternalTransferDetails.amount = data.amount;
    state.walletInternalTransferDetails.otpsent = data.otpsent;
    state.walletInternalTransferDetails.client_account_id = data.client_account_id;
    state.walletInternalTransferDetails.trading_account_no = data.trading_account_no;
  },
  [MAM__WALLET__MUTATIONS.MAMWALLETWITHDRAWDETAILS](state, data) {
    state.mamWalletWithdrawDetails.amount = data.amount;
    state.mamWalletWithdrawDetails.wallet_type = data.wallet_type;
    state.mamWalletWithdrawDetails.withdraw_method = data.withdraw_method;
    state.mamWalletWithdrawDetails.wallet_address = data.wallet_address;
    state.mamWalletWithdrawDetails.network = data.network;
    state.mamWalletWithdrawDetails.bank_id = data.bank_id;
    state.mamWalletWithdrawDetails.otpsent = data.otpsent;
  },
  [MAM__WALLET__MUTATIONS.MAMWALLETWITHDRAWFINISH](state) {
    state.mamWalletWithdrawDetails = {
      amount: null,
      wallet_type: null,
      withdraw_method: null,
      wallet_address: null,
      network: null,
      bank_id: null,
      otpsent: false,
    };
  },
};

const actions = {
  async [MAM__WALLET__ACTIONS.USERMAMWALLETSUMMARY]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(MAM__WALLET__API.USERMAMWALLETSUMMARY);
      commit(MAM__WALLET__MUTATIONS.USERMAMWALLETSUMMARY, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [MAM__WALLET__ACTIONS.WALLETTRANSACTIONHISTORY]({ commit, state }) {
    try {
      
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(MAM__WALLET__API.WALLETTRANSACTIONHISTORY);
      
      if (response.status === 200) {
        commit(MAM__WALLET__MUTATIONS.WALLETTRANSACTIONHISTORY, response.data);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [MAM__WALLET__ACTIONS.INVESTORWALLETHISTORY]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(MAM__WALLET__API.INVESTORWALLETHISTORY);
      commit(MAM__WALLET__MUTATIONS.INVESTORWALLETHISTORY, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [MAM__WALLET__ACTIONS.MANAGERWALLETHISTORY]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(MAM__WALLET__API.MANAGERWALLETHISTORY);
      commit(MAM__WALLET__MUTATIONS.MANAGERWALLETHISTORY, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  // Internal Transfer
  async [MAM__WALLET__ACTIONS.MAMWALLETINTERNALTRANSFERACCOUNT]({ commit, state }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(
        MAM__WALLET__API.MAMWALLETINTERNALTRANSFERACCOUNT
      );

      commit(MAM__WALLET__MUTATIONS.MAMWALLETINTERNALTRANSFERACCOUNT, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [MAM__WALLET__ACTIONS.WALLETINTERNALTRANSFERCODE]({ commit }, data) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(MAM__WALLET__API.WALLETINTERNALTRANSFERCODE, data);

      commit(MAM__WALLET__MUTATIONS.WALLETINTERNALTRANSFERDETAILS, {
        ...data,
        otpsent: response.data.otpsent,
      });

      return response.data; // ✅ Return to component

    } catch (error) {
      console.error(error);
      commit(MAM__WALLET__MUTATIONS.WALLETINTERNALTRANSFERDETAILS, {
        ...data,
        otpsent: false,
      });
      throw error; // ✅ Let the component handle toast
    }
  },
async [MAM__WALLET__ACTIONS.CONFIRMWALLETINTERNALTRANSFER]({ commit, state }, data) {
  const payload = {
    fromAccountID: state.walletInternalTransferDetails.fromAccountID,
    toAccountID: state.walletInternalTransferDetails.toAccountID,
    amount: state.walletInternalTransferDetails.amount,
    code: data.code,
    client_account_id: state.walletInternalTransferDetails.client_account_id,
    trading_account_no: state.walletInternalTransferDetails.trading_account_no,
  };

  try {
    console.log("Sending payload:", payload);

    const response = await HTTP({
      trackProgress: true,
      loadingText: 'Processing...'
    }).post(MAM__WALLET__API.CONFIRMWALLETINTERNALTRANSFER, payload);

    if (response.status === 200) {
      const message = response.data.message || "Successfully transferred";
      toast.success(message);
      state.walletInternalTransferDetails = {
        status: response.data.status,
        message: response.data.message,
        timestamp: new Date().toISOString()
      };
      console.log("✅ Transfer successful:", response.data);
    }
  } catch (error) {
    console.error("❌ CONFIRMWALLETINTERNALTRANSFER error:", {
      message: error.message,
      response: error.response,
      full: error,
      payload // ✅ now accessible
    });
  }
},

// MAM Wallet Withdraw
async [MAM__WALLET__ACTIONS.MAMWALLETWITHDRAWCODE]({ commit }, data) {
  try {
    const response = await HTTP({
      trackProgress: true,
      loadingText: 'Processing...'
    }).post(MAM__WALLET__API.MAMWALLETWITHDRAWCODE, data);

    commit(MAM__WALLET__MUTATIONS.MAMWALLETWITHDRAWDETAILS, {
      ...data,
      otpsent: response.data.otpsent,
    });
    toast.success(response.data.message || "OTP sent successfully");
    return response.data;

  } catch (error) {
    console.error(error);
    commit(MAM__WALLET__MUTATIONS.MAMWALLETWITHDRAWDETAILS, {
      ...data,
      otpsent: false,
    });
    toast.error(error.response.data.message || "Failed to send OTP");
    throw error;
  }
},

async [MAM__WALLET__ACTIONS.CONFIRMMAMWALLETWITHDRAW]({ commit, state }, data) {
  const payload = {
    amount: state.mamWalletWithdrawDetails.amount,
    wallet_type: state.mamWalletWithdrawDetails.wallet_type,
    withdraw_method: state.mamWalletWithdrawDetails.withdraw_method,
    wallet_address: state.mamWalletWithdrawDetails.wallet_address,
    network: state.mamWalletWithdrawDetails.network,
    bank_id: state.mamWalletWithdrawDetails.bank_id,
    code: data.code,
  };

  try {
    const response = await HTTP({
      trackProgress: true,
      loadingText: 'Processing...'
    }).post(MAM__WALLET__API.CONFIRMMAMWALLETWITHDRAW, payload);

    if (response.status === 200) {
      toast.success(response.data.message || "Withdrawal successful");
      commit(MAM__WALLET__MUTATIONS.MAMWALLETWITHDRAWFINISH);
      router.push("/mam-wallet");
    }
  } catch (error) {
    toast.error(error.response.data.message || "Withdrawal failed");
    console.error("❌ CONFIRMMAMWALLETWITHDRAW error:", {
      message: error.message,
      response: error.response,
      full: error,
      payload
    });
  }
}
};

export default {
  namespaced: true,
  strict: true,
  state,
  getters,
  actions,
  mutations,
};